import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom';
import { http } from 'helpers/axios';
import { open } from 'store/modules/modal';
import Uploader from '../components/Uploader';
import {
  cancel,
  selected,
  experienceAdded,
  downloadFile,
  updateComplianceStatus,
} from '../modules';

let complianceStatusCheckId;

const initialValues = {
  id: '',
  name: '',
  text: '',
};

const validate = values => {
  const errors = {};
  const requiredFields = ['id', 'name', 'text'];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });
  return errors;
};

const $reduxForm = reduxForm({
  form: 'createAssetForm',
  validate,
  initialValues,

  onSubmit(experience) {
    // Create asset
    // return http.post('/assets', {
    //   name: experience.name,
    //   description: experience.description,
    //   campaign: experience.id,
    //   package: experience.package,
    //   files: experience.files,
    // });
    return http.post('/experiences', {
      name: experience.name,
      text: experience.text,
      URL_LogoImage: 'url',
      landingImage: experience.fileLandingImage,
      landingPageZip: experience.landingPageZip,
      campaign: experience.campaign,
      expId: experience.expId,
      indexURL: experience.indexURL,
      landingImageURL: experience.landingImageURL,
    });
  },

  onSubmitSuccess({ data }, dispatch, props) {
    dispatch(experienceAdded(data));
    props.reset(); // clear redux form
  },

  onSubmitFail(formErrors, dispatch, submitError) {
    if (submitError) {
      dispatch(
        open({
          modalType: 'error',
          modalProps: {
            message: `Experience could not be created. Detail: ${
              submitError.message
            }`,
          },
        })
      );
    }
  },
});

const mapStateToProps = state => {
  return {
    auth: state.auth,
    mam: state.mam,
    selected: selected(state),
    progress: state.mam.progress,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  cancel() {
    dispatch(cancel());
  },

  downloadFile(fileId, fileName, totalBytes) {
    dispatch(downloadFile(fileId, fileName, totalBytes));
  },

  updateComplianceStatus(campaignId) {
    complianceStatusCheckId = setTimeout(() => {
      dispatch(updateComplianceStatus(campaignId)).then(() => {
        this.updateComplianceStatus(campaignId);
      });
    }, 10000); // 30 seconds
  },

  // deletePackage(experience) {
  //   dispatch(
  //     open({
  //       modalType: 'confirm',
  //       modalProps: {
  //         message: `Delete package '${experience.package.name}'?`,
  //         id: experience.package.id,
  //         handleYes: packageId => {
  //           dispatch(deletePackage(experience));
  //         },
  //       },
  //     })
  //   );
  // },
});

const enhance = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      this.props.change('id', this.props.match.params.id);
      this.props.updateComplianceStatus(this.props.match.params.id);
    },
    componentWillUnmount() {
      clearTimeout(complianceStatusCheckId);
    },
  })
);

export default $reduxForm(enhance(Uploader));
